import { Trash2, Plus, Pencil, X, Search } from "lucide-react";

export const VideosTab = ({ form, setForm, editingId, resetForm, submit, formRef, vq, setVq, videos, startEdit, del }) => {
  const input = (name, ph, extra = {}) => (
    <input data-testid={`admin-video-${name}`} value={form[name]} placeholder={ph}
      onChange={(e) => setForm({ ...form, [name]: e.target.value })} {...extra}
      className="w-full bg-transparent border border-white/20 focus:border-[#C5A059] outline-none px-3 py-2 text-[#EBE9E1] placeholder:text-[#555] rounded-sm text-sm" />
  );

  const select = (name, opts) => (
    <select data-testid={`admin-video-${name}`} value={form[name]}
      onChange={(e) => setForm({ ...form, [name]: e.target.value })}
      className="w-full bg-[#121418] border border-white/20 focus:border-[#C5A059] outline-none px-3 py-2 text-[#EBE9E1] rounded-sm text-sm">
      {opts.map((o) => <option key={o.value} value={o.value} className="bg-[#121418]">{o.label}</option>)}
    </select>
  );

  return (
    <div className="grid lg:grid-cols-3 gap-8">
      <form ref={formRef} onSubmit={submit} className="border border-white/10 bg-[#121418] p-6 space-y-3 h-fit">
        <div className="flex items-center justify-between mb-2">
          <h3 className="font-serif text-2xl text-[#EBE9E1]">{editingId ? "Edit Video" : "Add Video"}</h3>
          {editingId && (
            <button type="button" data-testid="admin-cancel-edit" onClick={resetForm} className="text-[#8A8F98] hover:text-[#EBE9E1] flex items-center gap-1 text-xs">
              <X size={14} /> Cancel
            </button>
          )}
        </div>
        {input("title", "Title", { required: true })}
        {input("original_title", "Original source title (if different)")}
        {input("youtube_id", "YouTube ID (e.g. oMhUu8kU6gE)")}
        {input("content_type", "Content type (e.g. Seminar, Interview)")}
        {input("areas_of_study", "Areas of study (comma separated)")}
        {input("subject", "Subject / technique")}
        {input("tags", "Tags (comma separated)")}
        {input("recording_date", "Recording date (e.g. 1994-05-18)")}
        {input("location", "Location / Dojo")}
        {input("duration", "Duration (e.g. 42:15)")}
        {input("source", "Source (channel / contributor)")}
        {input("collection", "Collection")}
        <div className="pt-2 border-t border-white/10 space-y-3">
          <p className="text-[10px] tracking-[0.3em] uppercase text-[#8A8F98]">Provenance & Status</p>
          <div>
            <label className="text-[10px] tracking-widest uppercase text-[#8A8F98]">Collection</label>
            {select("collection_group", [
              { value: "", label: "— (default: Chiba Sensei Archive)" },
              { value: "Chiba Sensei Archive", label: "Chiba Sensei Archive" },
              { value: "Legacy & Lineage", label: "Legacy & Lineage" },
            ])}
          </div>
          {input("uploader", "Uploader")}
          {input("videographer", "Videographer")}
          {input("media_owner", "Media owner")}
          {input("source_archive", "Source archive")}
          {input("rights_holder", "Rights holder")}
          <div>
            <label className="text-[10px] tracking-widest uppercase text-[#8A8F98]">Verification</label>
            {select("verification_status", [
              { value: "", label: "— (use default: Needs Research)" },
              { value: "Needs Research", label: "Needs Research" },
              { value: "Under Review", label: "Under Review" },
              { value: "Verified", label: "Verified" },
            ])}
          </div>
          <div>
            <label className="text-[10px] tracking-widest uppercase text-[#8A8F98]">Source health</label>
            {select("source_status", [
              { value: "", label: "— (auto)" },
              { value: "Available", label: "Available" },
              { value: "Source unavailable", label: "Source unavailable" },
              { value: "Under review", label: "Under review" },
            ])}
          </div>
        </div>
        {input("notes", "Notes (internal — not shown publicly)")}
        {input("description", "Description")}
        <button data-testid="admin-add-video-btn" type="submit" className="btn-primary w-full py-2 font-medium flex items-center justify-center gap-2">
          {editingId ? <><Pencil size={16} /> Save Changes</> : <><Plus size={16} /> Add to Library</>}
        </button>
      </form>
      <div className="lg:col-span-2 border border-white/10 bg-[#121418] flex flex-col">
        <div className="flex items-center gap-3 px-4 py-3 border-b border-white/10">
          <Search size={16} className="text-[#8A8F98]" />
          <input data-testid="admin-video-list-search" value={vq} onChange={(e) => setVq(e.target.value)}
            placeholder="Find a video to edit…"
            className="bg-transparent outline-none text-[#EBE9E1] placeholder:text-[#555] w-full text-sm" />
        </div>
        <div className="max-h-[560px] overflow-y-auto">
          {videos.map((v) => (
            <div key={v.id} data-testid={`admin-video-row-${v.id}`}
              className={`flex items-center justify-between px-5 py-3 border-b border-white/5 ${editingId === v.id ? "bg-[#1A1D24]" : ""}`}>
              <div className="min-w-0">
                <p className="text-[#EBE9E1] text-sm truncate">{v.title}</p>
                <p className="text-[#8A8F98] text-xs">{v.category || v.subject} · {v.year || "—"} · {v.location || "—"}</p>
              </div>
              <div className="flex items-center gap-3 shrink-0 ml-4">
                <button data-testid={`admin-edit-${v.id}`} onClick={() => startEdit(v.id)} className="text-[#8A8F98] hover:text-[#C5A059]" title="Edit">
                  <Pencil size={15} />
                </button>
                <button data-testid={`admin-delete-${v.id}`} onClick={() => del(v.id)} className="text-[#8A8F98] hover:text-[#8B2626]" title="Delete">
                  <Trash2 size={15} />
                </button>
              </div>
            </div>
          ))}
          {videos.length === 0 && <p className="text-[#8A8F98] text-sm p-5">No matching videos.</p>}
        </div>
      </div>
    </div>
  );
};
